import { DialogModule } from '@angular/cdk/dialog';

import { Component } from '@angular/core';
import { AbstractButton, PopoutButtonComponent } from '@jeppesen-foreflight/jmkw-toolkit';
import { UnitConfigPopoutComponent } from './popout/unit-config.popout.component';
import { ButtonParams } from '@jeppesen-foreflight/jmkw-types';

@Component({
  standalone: true,
  imports: [DialogModule, PopoutButtonComponent],
  templateUrl: './unit-config.button.html'
})
export class UnitConfigButtonComponent extends AbstractButton {
  iconName = 'icon-settings';
  automationKey = 'unit-config-button';
  tooltipText = 'Unit Configurations';
  componentRef = UnitConfigPopoutComponent;
}

// Button params for the settings button
export const UNIT_CONFIG_BUTTON: ButtonParams = {
  iconName: 'icon-settings',
  tooltipText: 'Unit Configurations',
  buttonComponent: UnitConfigButtonComponent,
  stateFn: () => false // Button is never in "active" state
};
